<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-table :data="dconfData"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="id" label="ID" width="130"></el-table-column>
        <el-table-column prop="title" label="名称" width="150"></el-table-column>
        <el-table-column label="弹窗图片" width="150">
          <template slot-scope="scope">
            <el-popover placement="right" width="450" trigger="hover" >
              <img :src="scope.row.tc_picture" style="width:100%;">
              <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.tc_picture"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="tc_link" label="跳转地址" width="500"></el-table-column>
        <el-table-column prop="is_tanchu" label="启用状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_tanchu=='true'">启用</el-tag>
            <el-tag v-else type="danger">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
     <div v-if="total_count > params.pageSize" class="content-padded tc">
      <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
      </el-pagination>
    </div>

      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label="弹窗图片" label-width="100px" prop="img">
            <div @click="handleImgPicker('tc_picture')" class="upload-box">
              <img v-if="updateForm.tc_picture" :src="updateForm.tc_picture" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
          </el-form-item>

          <el-form-item label-width="100px" label="跳转地址" v-if="updateForm.tc_type > 1">
            <el-input v-model="updateForm.tc_link" placeholder="跳转地址"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="启用状态">
            <el-radio-group v-model="updateForm.is_tanchu" size="small">
              <el-radio-button :label="'false'">关闭</el-radio-button>
              <el-radio-button :label="'true'">启用</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
      <imgPicker
        :dialog-visible="imgDialog"
        :sc-status="isGetImage"
        @chooseImg="pickImg"
        @closeImgDialog="closeImgDialog"
      ></imgPicker>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {tanchuangList, updateIcon, updateTanchuang} from '../../../api/sharer'
import imgPicker from '@/components/imageselect'
export default {
  components: { imgPicker },
  data () {
    return {
      total_count: 0,
      dialogTitle: '',
      loading: false,
      dconfData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      updateForm: {
        id: '',
        tc_type: '',
        tc_picture: '',
        tc_link: '',
        is_tanchu: ''
      },
      editInfoDialog: false,
      pickerImgType: '',
      imgDialog: false,
      isGetImage: false
    }
  },
  methods: {
    getTanchuangList (filter) {
      this.loading = true
      tanchuangList(filter).then(response => {
        this.dconfData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      if (row) {
        this.updateForm.id = row.id
        this.updateForm.tc_type = row.tc_type
        this.updateForm.tc_picture = row.tc_picture
        this.updateForm.tc_link = row.tc_link
        this.updateForm.is_tanchu = row.is_tanchu
      } else {
        this.dialogTitle = '首页弹窗设置'
      }
    },
    editInfoSubmit () {
      updateTanchuang({id: this.updateForm.id,tc_type: this.updateForm.tc_type, tc_picture: this.updateForm.tc_picture, tc_link: this.updateForm.tc_link, is_tanchu: this.updateForm.is_tanchu}).then(res => {
        this.$message({ type: 'success', message: '更新成功'})
        this.editInfoDialog = false
        this.getTanchuangList(this.params)
      })
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getTanchuangList(this.params)
    },
    pickImg (data) {
      this.updateForm[this.pickerImgType] = data.url
      this.imgDialog = false
    },
    handleImgPicker (pickerImgType) {
      this.pickerImgType = pickerImgType
      this.imgDialog = true
      this.isGetImage = true
    },
    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    }
  },
  mounted () {
    this.getTanchuangList(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    dconfData: {
      handler (value) {
        if (this.allCheck) {
          this.dconfData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style>
.frm-tips {
  color: #e76c34;
}
</style>



// WEBPACK FOOTER //
// tanchuang_list.vue?0af59c96